import { render, staticRenderFns } from "./questionnaireStatistics.vue?vue&type=template&id=8192955a"
import script from "./questionnaireStatistics.vue?vue&type=script&lang=js"
export * from "./questionnaireStatistics.vue?vue&type=script&lang=js"
import style0 from "./questionnaireStatistics.vue?vue&type=style&index=0&id=8192955a&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports